import { createSelector } from 'reselect';

const selectBusinessUsers = (state: any) => state.businessUser;


export const selectBusinessUsersCurrentItem = createSelector([selectBusinessUsers], (businessUser) => businessUser.current);

export const selectBusinessUsersListItems = createSelector([selectBusinessUsers], (businessUser) => businessUser.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectBusinessUsersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBusinessUsersQueryItems = createSelector([selectBusinessUsers], (businessUser) => businessUser.query);

export const selectBusinessUsersCreatedItem = createSelector([selectBusinessUsers], (businessUser) => businessUser.create);

export const selectBusinessUsersUpdatedItem = createSelector([selectBusinessUsers], (businessUser) => businessUser.update);

export const selectBusinessUsersReadItem = createSelector([selectBusinessUsers], (businessUser) => businessUser.read);

export const selectBusinessUsersDeletedItem = createSelector([selectBusinessUsers], (businessUser) => businessUser.delete);

export const selectBusinessUsersSearchedItems = createSelector([selectBusinessUsers], (businessUser) => businessUser.search);

export const selectBusinessUsersItemsCount = createSelector([selectBusinessUsers], (businessUser) => businessUser.count);

export const selectBusinessUsersItemsFilter = createSelector([selectBusinessUsers], (businessUser) => businessUser.filter);